import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IPermissionRole } from 'src/app/authentication/models/permission-role';
import { RoleService } from 'src/app/authentication/services/role.service';

@Injectable({
  providedIn: 'root'
})
export class PremissionRolesResolver  {
constructor(private permissionRoleService : RoleService){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<IPermissionRole[]> {
      return this.permissionRoleService.listRoles({pageNumber: 0, pageSize: 999999});
  }
}
